import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import {
  INSURANCE_DESCLAIMER,
  TermsText,
  TermsTextArbitrage,
  TermsTextCarsStandard,
  TermsTextEuStandard,
  TermsTextSubscription
} from '../ff-shared/milData';
import {
  INSURANCE_DESCLAIMER_EN,
  TermsText_EN,
  TermsTextArbitrage_EN,
  TermsTextCarsStandard_EN,
  TermsTextEuStandard_EN,
  TermsTextSubscription_EN
} from '../ff-shared/milData.en';

@Injectable({
  providedIn: 'root'
})
export class TermsService {

  constructor(private translate: TranslateService) {}

  private isEnglish(): boolean {
    return (localStorage.getItem('language') || this.translate.currentLang) === 'en';
  }

  getTermsText(): string {
    return this.isEnglish() ? TermsText_EN : TermsText;
  }

  getTermsTextCarsStandard(): string {
    return this.isEnglish() ? TermsTextCarsStandard_EN : TermsTextCarsStandard;
  }

  getTermsTextEuStandard(): string {
    return this.isEnglish() ? TermsTextEuStandard_EN : TermsTextEuStandard;
  }

  getTermsTextSubscription(): string {
    return this.isEnglish() ? TermsTextSubscription_EN : TermsTextSubscription;
  }

  getTermsTextArbitrage(): string {
    return this.isEnglish() ? TermsTextArbitrage_EN : TermsTextArbitrage;
  }

  getInsuranceDisclaimer(): string {
    return this.isEnglish() ? INSURANCE_DESCLAIMER_EN : INSURANCE_DESCLAIMER;
  }
}
